/**
 * Crockford base-32 ULID: a 48-bit millisecond timestamp followed by 80 bits of randomness.
 *
 * Generated in the browser because the ids it produces are for AMS working sessions and session
 * events, which the caller mints -- there is no create call to get one from.
 */
export function generateUlid(): string {
  const alphabet = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
  let timestamp = Date.now();
  let time = "";
  for (let index = 0; index < 10; index += 1) {
    time = alphabet[timestamp % 32] + time;
    timestamp = Math.floor(timestamp / 32);
  }

  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  let random = "";
  for (let index = 0; index < 16; index += 1) {
    random += alphabet[bytes[index]! % 32];
  }

  return time + random;
}
